import { useRef, useState } from "react";
import { MenuItemAction } from "../../Menu/MenuItem.Dto";
import { useNavigate } from "react-router-dom";
import { CTeDto } from "./CTe.Dto";
import { showToast } from "src/componentes";
import { CTeBuscarXML } from "src/services/Fiscal.Service";

type CTeMenuCodeProps = {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  data: CTeDto[];
  onNovoCTe?: () => void;
  onImportarXmlNFe?: () => void;
};

const CTeMenuCode = (props: CTeMenuCodeProps) => {
  const navigate = useNavigate();
  const dataRef = useRef<CTeDto[]>(props.data);
  dataRef.current = props.data;

  const onNovoCTeRef = useRef(props.onNovoCTe);
  onNovoCTeRef.current = props.onNovoCTe;

  const onImportarXmlNFeRef = useRef(props.onImportarXmlNFe);
  onImportarXmlNFeRef.current = props.onImportarXmlNFe;

  const onDownloadXml = async () => {
    props.setLoading(true);
    const dataAtual = dataRef.current;
    if (dataAtual.length === 0) {
      showToast({
        message: "Nenhum CT-e selecionado",
        title: "Atenção",
        variant: "Warning",
      });
      props.setLoading(false);
      return;
    }
    try {
      const primeiro = dataAtual[0];
      const ultimo = dataAtual[dataAtual.length - 1];
      const ids = dataAtual
        .map((item) => item.id)
        .filter((id): id is number => id !== undefined && id > 0);

      if (ids.length === 0) {
        showToast({
          message: "Nenhum CT-e válido encontrado",
          title: "Atenção",
          variant: "Warning",
        });
        props.setLoading(false);
        return;
      }

      const nomeArquivo = `CTe_${primeiro?.numeroCte}_${ultimo?.numeroCte}`;
      const response = await CTeBuscarXML(ids, nomeArquivo);
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${nomeArquivo}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao baixar XML",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      props.setLoading(false);
    }
  };

  const menuPrincipal: MenuItemAction[] = [
    {
      id: 1,
      nome: "Novo CT-e...",
      rota: props.onNovoCTe ? "" : "/fiscal/cte/cadastro",
      sequencia: 1,
      nivel: 1,
      idNivelAnterior: 0,
      action: () => {
        if (onNovoCTeRef.current) {
          onNovoCTeRef.current();
        } else {
          navigate("/fiscal/cte/cadastro");
        }
      },
    },
    {
      id: 2,
      nome: "Importar XML NF-e...",
      rota: props.onImportarXmlNFe ? "" : "/fiscal/cte/importar-xml",
      sequencia: 2,
      nivel: 1,
      idNivelAnterior: 0,
      action: () => {
        if (onImportarXmlNFeRef.current) {
          onImportarXmlNFeRef.current();
        } else {
          navigate("/fiscal/cte/importar-xml");
        }
      },
    },
    {
      id: 3,
      nome: "Baixar XML",
      rota: "",
      sequencia: 3,
      nivel: 1,
      idNivelAnterior: 0,
      action: onDownloadXml,
    },
  ];

  const [menuItens, setMenuItens] = useState<MenuItemAction[]>(menuPrincipal);

  const handleMenuClick = (item: MenuItemAction) => (e: React.MouseEvent) => {
    if (item.children && item.children.length > 0) {
      e.stopPropagation();
      setMenuItens(item.children);
    } else if (item.action) {
      item.action();
    } else if (item.rota) {
      navigate(item.rota);
    }
  };

  const handleMenuToggleClick = (isOpen: boolean) => {
    if (!isOpen) {
      setMenuItens(menuPrincipal);
    }
  };

  return {
    handleMenuClick,
    handleMenuToggleClick,
    menuItens,
  };
};

export default CTeMenuCode;
